import { put, call } from "redux-saga/effects";
import { exceptionHandler } from "../pages/common/functions";
import { promiseLandConstants } from "../actions/constants/promiseLandConstant";
import PromiseLandService from "../services/api/promiseLandService";

function* promiseLandSave(request: any) {
	try {
		const result = yield call(PromiseLandService.promiseLandSave, request.input);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: promiseLandConstants.PromiseLandSaveSuccess,
				payload: res.data
			});
		}
		else {
			yield put({ type: promiseLandConstants.PromiseLandSaveFailure, payload: res.data });
		}

	} catch (error) {
		yield put({ type: promiseLandConstants.PromiseLandSaveFailure, payload: error });
	}
}

function* promiseLandGetByFilter(request) {
	try {
		const result = yield call(PromiseLandService.promiseLandGetByFilter, request.input);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: promiseLandConstants.PromiseLand_GetByFilter_Success,
				payload: res.data,
			});
		} else {
			yield put({
				type: promiseLandConstants.PromiseLand_GetByFilter_Failure,
				payload: res.data,
			});
		}
	} catch (e) {
		yield put({
			type: promiseLandConstants.PromiseLand_GetByFilter_Failure,
			payload: e,
		});
	}
}

function* promiseLandGetAllBooks() {
	try {
		const result = yield call(PromiseLandService.promiseLandGetAllBooks);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: promiseLandConstants.PromiseLandGetBooksSuccess,
				payload: res.data,
			});
		} else {
			yield put({
				type: promiseLandConstants.PromiseLandGetBooksFailure,
				payload: res.data,
			});
		}
	} catch (error) {
		yield put({
			type: promiseLandConstants.PromiseLandGetBooksFailure,
			payload: error,
		});
	}
}

function* promiseLandGetDetail(request: any) {
	try {
		const result = yield call(
			PromiseLandService.promiseLandGetDetail,
			request.input
		);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: promiseLandConstants.PromiseLandDetailSuccess,
				payload: res.data,
			});
		} else {
			yield put({
				type: promiseLandConstants.PromiseLandDetailFailure,
				payload: res.data,
			});
		}
	} catch (error) {
		yield put({
			type: promiseLandConstants.PromiseLandDetailFailure,
			payload: error,
		});
	}
}

function* promiseLandDelete(request: any) {
	try {
		const result = yield call(PromiseLandService.promiseLandDelete, request.input);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: promiseLandConstants.PromiseLandDeleteSuccess,
				payload: res.data
			});
		}
		else {
			yield put({ type: promiseLandConstants.PromiseLandDeleteFailure, payload: res.data });
		}
	} catch (error) {
		yield put({ type: promiseLandConstants.PromiseLandDeleteFailure, payload: error });
	}
}

export const promiseLandSaga = {
	promiseLandGetByFilter,
	promiseLandGetDetail,
	promiseLandGetAllBooks,
	promiseLandSave,
	promiseLandDelete
};
